import React, {forwardRef} from 'react';
import { VictoryPie } from "victory-pie";

const ChPieChart = (props) => {

    const {
            width = 40, height = 40,
            radius= 20, x = 10, y = 10,
            percentFilled = 50,
            color = '#49C6B5'} = props;

    const data = [
        {x:' ', y:percentFilled},
        {x:' ', y:100-percentFilled}
    ];

    return (
        <VictoryPie
            {...props}
            width={width}
            height={height}
            // startAngle={45}
            // endAngle={450}
            data={data}
            colorScale={[color,'#e8e8e8']}
            radius={radius}
        />
    );
}

export default ChPieChart;
